// Mock data for Alpes Debouchage website

export const companyInfo = {
  name: "Alpes Debouchage",
  legalName: "Alpes Debouchage",
  siret: "903 003 457",
  slogan: "Experts en débouchage et assainissement",
  phone: "07 44 87 87 63",
  email: "contact.cannes.debouchage06@gmail.com",
  address: "10 rue Jean Cresp, 06400 Cannes",
  availability: "24h/24 - 7j/7",
  zone: "Cannes et tout le département 06",
  logo: "https://customer-assets.emergentagent.com/job_0ab86c0e-4c4f-4ff6-8208-82e18036900c/artifacts/y4o6k46n_A5B34F9F-5E70-4C7E-93F3-B66420FB0B56.png",
  social: {
    instagram: "https://www.instagram.com/debouchage_cannes?igsh=MTduYWRmdTFkbngydw==",
    tiktok: "https://www.tiktok.com/@debouchage.cote.d?_r=1&_t=ZN-93U9DznvPss"
  }
};

export const services = [
  {
    id: 1,
    title: "Débouchage Canalisation",
    description: "Débouchage manuel pour toutes vos canalisations bouchées : évier, lavabo, douche, baignoire. Intervention rapide et efficace.",
    price: "À partir de 179€ HT",
    icon: "Wrench",
    image: "https://customer-assets.emergentagent.com/job_0ab86c0e-4c4f-4ff6-8208-82e18036900c/artifacts/ub9nmn6u_942bcdaf-dd46-45be-a688-fe59fc0feba3.jpeg",
    features: ["Débouchage manuel", "Furet électrique", "Pompe à pression", "Diagnostic inclus"]
  },
  {
    id: 2,
    title: "Curage Haute Pression",
    description: "Nettoyage complet de vos canalisations par hydrocurage. Élimination du calcaire, graisses et dépôts. Tarif sur devis selon mètre linéaire.",
    price: "À partir de 289€ HT",
    icon: "Waves",
    image: "https://customer-assets.emergentagent.com/job_0ab86c0e-4c4f-4ff6-8208-82e18036900c/artifacts/eyie51aq_2ab4370d-1d23-42df-bb80-8b8bc30743af.jpeg",
    features: ["Jusqu'à 300 bars", "100% écologique", "Détartrage complet", "Sur devis"]
  },
  {
    id: 3,
    title: "Inspection Caméra",
    description: "Diagnostic précis de l'état de vos canalisations grâce à notre caméra endoscopique haute définition. Rapport détaillé en option.",
    price: "À partir de 249€ HT",
    icon: "Camera",
    image: "https://customer-assets.emergentagent.com/job_0ab86c0e-4c4f-4ff6-8208-82e18036900c/artifacts/57hunb5n_b5d348ed-6d4c-4b65-a76d-319bf33035ba.jpeg",
    features: ["Caméra HD", "Localisation bouchon", "Sur devis", "Rapport détaillé en option"]
  },
  {
    id: 4,
    title: "Entretien Bac à Graisse",
    description: "Vidange et nettoyage complet de votre bac à graisse pour les professionnels de la restauration et particuliers.",
    price: "À partir de 289€ HT",
    icon: "Trash2",
    image: "https://customer-assets.emergentagent.com/job_0ab86c0e-4c4f-4ff6-8208-82e18036900c/artifacts/mf96pjx5_32264f78-cbe1-429a-91d8-4d43997d1cd2.jpeg",
    features: ["Pompage des graisses", "Nettoyage HP", "Remise en service", "Contrat d'entretien"]
  },
  {
    id: 5,
    title: "Contrat Pompe de Relevage",
    description: "Contrat d'entretien pour vos pompes de relevage eaux usées ou pluviales. Maintenance préventive et dépannage.",
    price: "À partir de 279€ HT",
    icon: "Settings",
    image: "https://customer-assets.emergentagent.com/job_0ab86c0e-4c4f-4ff6-8208-82e18036900c/artifacts/8jwx5wyv_216fb42e-bb29-4739-acbe-112b69c37427.jpeg",
    features: ["Entretien régulier", "Diagnostic complet", "Intervention prioritaire", "Dépannage inclus"]
  }
];

export const features = [
  {
    id: 1,
    title: "Intervention 24h/24",
    description: "Urgence ou rendez-vous, nous sommes disponibles jour et nuit",
    icon: "Clock"
  },
  {
    id: 2,
    title: "Devis Gratuit",
    description: "Estimation transparente sans engagement avant intervention",
    icon: "FileText"
  },
  {
    id: 3,
    title: "Techniciens Qualifiés",
    description: "Équipe expérimentée et formée aux dernières techniques",
    icon: "Award"
  },
  {
    id: 4,
    title: "Équipement Pro",
    description: "Camion hydrocureur et matériel dernière génération",
    icon: "Truck"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie L.",
    location: "Cannes",
    rating: 5,
    text: "Intervention très rapide pour un WC bouché un dimanche soir. Le technicien était professionnel et sympathique. Je recommande !",
    date: "Janvier 2025"
  },
  {
    id: 2,
    name: "Pierre D.",
    location: "Antibes",
    rating: 5,
    text: "Excellent service pour le curage de mes canalisations. Prix correct et travail impeccable. Entreprise sérieuse.",
    date: "Décembre 2024"
  },
  {
    id: 3,
    name: "Restaurant Le Méditerranée",
    location: "Mougins",
    rating: 5,
    text: "Nous faisons appel à Alpes Debouchage pour l'entretien de notre bac à graisse. Service fiable et régulier depuis 2 ans.",
    date: "Novembre 2024"
  },
  {
    id: 4,
    name: "Jean-Marc R.",
    location: "Grasse",
    rating: 5,
    text: "Vidange de fosse septique effectuée rapidement. L'équipe est arrivée à l'heure et a fait un travail propre. Merci !",
    date: "Octobre 2024"
  },
  {
    id: 5,
    name: "Sophie M.",
    location: "Le Cannet",
    rating: 5,
    text: "Problème de canalisation bouchée résolu en moins d'une heure. Tarif annoncé respecté. Très satisfaite.",
    date: "Septembre 2024"
  }
];

export const faqItems = [
  {
    question: "Quel est le délai d'intervention en cas d'urgence ?",
    answer: "En cas d'urgence, nous nous efforçons d'intervenir dans les 2 heures suivant votre appel sur Cannes et ses environs. Pour les zones plus éloignées du 06, le délai peut varier mais reste toujours le plus court possible."
  },
  {
    question: "Comment sont calculés vos tarifs ?",
    answer: "Nos tarifs sont transparents et annoncés avant intervention. Ils comprennent le déplacement, le diagnostic et la main d'œuvre. Le matériel spécifique (comme l'hydrocurage) est facturé en supplément selon les besoins. Devis gratuit sur place."
  },
  {
    question: "Intervenez-vous pour les professionnels ?",
    answer: "Absolument ! Nous travaillons avec de nombreux professionnels : restaurants, hôtels, syndics de copropriété, commerces... Nous proposons également des contrats d'entretien adaptés à vos besoins."
  },
  {
    question: "Mon assurance couvre-t-elle l'intervention ?",
    answer: "Cela dépend de votre contrat d'assurance habitation. Nous fournissons systématiquement une facture détaillée et, si nécessaire, un rapport d'intervention avec photos/vidéo pour vos démarches auprès de votre assureur."
  },
  {
    question: "Quelle est votre zone d'intervention ?",
    answer: "Nous intervenons sur tout le département des Alpes-Maritimes (06) : Cannes, Antibes, Nice, Grasse, Mougins, Le Cannet, Mandelieu, Vallauris, Valbonne, Sophia-Antipolis et toutes les communes environnantes."
  },
  {
    question: "Utilisez-vous des produits chimiques ?",
    answer: "Non, nous privilégions les méthodes mécaniques (furet, pompe) et l'hydrocurage haute pression qui n'utilise que de l'eau. Ces techniques sont plus efficaces, écologiques et préservent vos canalisations."
  }
];

export const zones = [
  "Cannes", "Antibes", "Nice", "Grasse", "Mougins", 
  "Le Cannet", "Mandelieu-la-Napoule", "Vallauris", 
  "Valbonne", "Sophia-Antipolis", "Cagnes-sur-Mer",
  "Saint-Laurent-du-Var", "Vence", "Biot", "Mouans-Sartoux",
  "Pégomas", "La Roquette-sur-Siagne", "Théoule-sur-Mer",
  "Monaco", "Menton", "Villeneuve-Loubet", "Villefranche-sur-Mer",
  "Beaulieu-sur-Mer", "Saint-Jean-Cap-Ferrat", "Carros", "Roquebrune-Cap-Martin"
];

export const cityPages = [
  {
    slug: "cannes",
    name: "Cannes",
    postalCode: "06400",
    metaTitle: "Débouchage Cannes 06400 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Cannes (06400). WC, évier, douche bouchés ? Intervention rapide La Croisette, Palm Beach, Le Suquet. Week-ends et jours fériés. Devis gratuit.",
    description: "Cannes, célèbre pour son festival du cinéma et sa Croisette, est une ville où le prestige des résidences et hôtels de luxe exige un service de débouchage irréprochable. Nos techniciens interviennent rapidement dans tous les quartiers cannois.",
    quartiers: ["La Croisette", "Palm Beach", "Le Suquet", "Carnot", "République", "Petit Juas", "Californie", "La Bocca"],
    localInfo: "Avec ses nombreux hôtels de luxe, palaces et résidences de standing, Cannes nécessite des interventions discrètes et professionnelles. Nous intervenons régulièrement auprès des conciergeries et syndics de la ville.",
    typicalProblems: ["Canalisations anciennes dans le vieux Cannes", "Refoulements dans les immeubles de la Croisette", "Bacs à graisse des restaurants du port", "WC bouchés dans les résidences de vacances"],
    nearbyAreas: ["Le Cannet", "La Bocca", "Mandelieu-la-Napoule", "Mougins"]
  },
  {
    slug: "le-cannet",
    name: "Le Cannet",
    postalCode: "06110",
    metaTitle: "Débouchage Le Cannet 06110 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage au Cannet (06110). Intervention rapide centre-ville, Rocheville, Les Campelières. Canalisations bouchées ? Travail garanti. Devis gratuit.",
    description: "Le Cannet, ville résidentielle surplombant Cannes, possède un patrimoine architectural varié allant des villas Belle Époque aux résidences modernes. Nous connaissons parfaitement les spécificités des canalisations de chaque quartier.",
    quartiers: ["Centre-ville", "Rocheville", "Les Campelières", "Les Ardissons", "Saint-Sauveur", "Garibondy"],
    localInfo: "Ville d'art et d'histoire, Le Cannet compte de nombreuses maisons anciennes avec des réseaux d'évacuation parfois vétustes. Notre expertise permet d'intervenir sans endommager ces installations fragiles.",
    typicalProblems: ["Canalisations en plomb dans les villas anciennes", "Racines dans les évacuations des jardins", "Engorgements dans les copropriétés de Rocheville", "Fosses septiques des maisons individuelles"],
    nearbyAreas: ["Cannes", "Mougins", "Mouans-Sartoux", "Le Cannet-Rocheville"]
  },
  {
    slug: "la-bocca",
    name: "La Bocca",
    postalCode: "06150",
    metaTitle: "Débouchage La Bocca 06150 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à La Bocca (06150). WC, évier bouchés ? Intervention rapide quartier Ranguin, Frayère, plages. Week-ends et jours fériés. Devis gratuit.",
    description: "La Bocca, quartier populaire et dynamique de Cannes Ouest, est un secteur résidentiel et industriel où nous intervenons quotidiennement. Des plages de la Bocca aux quartiers du Ranguin, nous couvrons toute la zone.",
    quartiers: ["Ranguin", "La Frayère", "Pierre Longue", "Les Tourrades", "Bocca Centre", "Bocca Plage"],
    localInfo: "Quartier très actif avec de nombreux commerces et restaurants, La Bocca nécessite des interventions rapides pour ne pas perturber l'activité économique. Nous travaillons régulièrement avec les restaurateurs de la zone.",
    typicalProblems: ["Bacs à graisse des restaurants saturés", "Canalisations des immeubles HLM", "Engorgements liés au sable des plages", "Évacuations des zones industrielles"],
    nearbyAreas: ["Cannes", "Mandelieu-la-Napoule", "Pégomas", "Le Cannet"]
  },
  {
    slug: "mandelieu-la-napoule",
    name: "Mandelieu-la-Napoule",
    postalCode: "06210",
    metaTitle: "Débouchage Mandelieu-la-Napoule 06210 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Mandelieu (06210). Intervention Minelle, Capitou, port La Napoule. Canalisations bouchées ? Travail garanti. Devis gratuit.",
    description: "Mandelieu-la-Napoule, entre mer et montagne, est réputée pour son port de plaisance et ses golfs. Cette ville résidentielle prisée compte de nombreuses villas et résidences où nous intervenons régulièrement.",
    quartiers: ["La Napoule", "Minelle", "Capitou", "Les Termes", "Cannes Marina", "San Peyre"],
    localInfo: "Avec ses nombreuses résidences avec piscine et son port de plaisance, Mandelieu présente des problématiques spécifiques : évacuations de piscine, canalisations des bateaux, pompes de relevage des sous-sols.",
    typicalProblems: ["Évacuations des villas avec piscine", "Canalisations des bateaux au port", "Pompes de relevage des résidences", "Calcaire important dû à l'eau dure"],
    nearbyAreas: ["La Bocca", "Pégomas", "Théoule-sur-Mer", "Cannes"]
  },
  {
    slug: "grasse",
    name: "Grasse",
    postalCode: "06130",
    metaTitle: "Débouchage Grasse 06130 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Grasse (06130). Intervention vieille ville, Plan de Grasse, Magagnosc. Canalisations bouchées ? Travail garanti 24h/24. Devis gratuit.",
    description: "Grasse, capitale mondiale du parfum, est une ville au riche patrimoine historique avec une vieille ville médiévale aux ruelles étroites. Nos équipements compacts permettent d'intervenir même dans les accès les plus difficiles.",
    quartiers: ["Vieille ville", "Plan de Grasse", "Magagnosc", "Saint-Jacques", "Plascassier", "Les Parcs"],
    localInfo: "La vieille ville de Grasse possède des canalisations très anciennes, parfois du XIXe siècle. Notre expertise en débouchage de réseaux anciens est particulièrement appréciée par les propriétaires et syndics grassois.",
    typicalProblems: ["Canalisations centenaires de la vieille ville", "Racines des platanes dans les évacuations", "Fosses septiques des mas provençaux", "Engorgements des restaurants et parfumeries"],
    nearbyAreas: ["Mouans-Sartoux", "Mougins", "Le Bar-sur-Loup", "Pégomas"]
  },
  {
    slug: "pegomas",
    name: "Pégomas",
    postalCode: "06580",
    metaTitle: "Débouchage Pégomas 06580 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Pégomas (06580). Intervention village, zones résidentielles. WC, évier bouchés ? Week-ends et jours fériés. Devis gratuit.",
    description: "Pégomas, charmant village provençal entre Grasse et Cannes, est un secteur résidentiel calme bordé par la Siagne. Nous intervenons dans tout le village et ses environs pour tous vos problèmes de canalisation.",
    quartiers: ["Village", "Les Cabrières", "Le Logis", "La Fenerie", "Les Clausonnes"],
    localInfo: "Commune traversée par la Siagne, Pégomas compte de nombreuses maisons individuelles avec fosses septiques. Notre service d'entretien et débouchage de fosses est très sollicité dans ce secteur.",
    typicalProblems: ["Fosses septiques des maisons individuelles", "Engorgements après les crues de la Siagne", "Canalisations des vieilles maisons du village", "Racines dans les évacuations des jardins"],
    nearbyAreas: ["La Bocca", "Mandelieu-la-Napoule", "Mouans-Sartoux", "Grasse"]
  },
  {
    slug: "mougins",
    name: "Mougins",
    postalCode: "06250",
    metaTitle: "Débouchage Mougins 06250 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Mougins (06250). Intervention village, Font de l'Orme, Val de Mougins. Canalisations bouchées ? Travail garanti. Devis gratuit.",
    description: "Mougins, village gastronomique de renommée internationale, est un écrin de verdure prisé pour ses villas de prestige. Nous assurons un service discret et professionnel auprès des propriétaires et des grands restaurants mouginois.",
    quartiers: ["Village historique", "Font de l'Orme", "Val de Mougins", "Tournamy", "Les Bréguières", "Le Grand Duc"],
    localInfo: "Mougins compte de nombreux restaurants étoilés et villas de luxe avec des installations haut de gamme. Nous intervenons avec le plus grand soin et la discrétion requise pour ce type de clientèle.",
    typicalProblems: ["Bacs à graisse des restaurants gastronomiques", "Évacuations des piscines des villas", "Canalisations des propriétés de prestige", "Pompes de relevage des sous-sols"],
    nearbyAreas: ["Cannes", "Le Cannet", "Mouans-Sartoux", "Valbonne"]
  },
  {
    slug: "vallauris",
    name: "Vallauris",
    postalCode: "06220",
    metaTitle: "Débouchage Vallauris 06220 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Vallauris (06220). Intervention Golfe-Juan, centre-ville, Super Cannes. Canalisations bouchées ? Week-ends et jours fériés. Devis gratuit.",
    description: "Vallauris, cité des potiers rendue célèbre par Picasso, est une commune dynamique entre Cannes et Antibes. De Golfe-Juan à Super Cannes, nous couvrons l'ensemble du territoire vallaurien.",
    quartiers: ["Centre-ville", "Golfe-Juan", "Super Cannes", "Les Encourdoules", "Les Clausonnes", "Saint-Bernard"],
    localInfo: "Vallauris possède un tissu économique varié avec de nombreux artisans et commerces. Les ateliers de poterie nécessitent des évacuations performantes que nous entretenons régulièrement.",
    typicalProblems: ["Évacuations des ateliers de poterie", "Canalisations des villas de Super Cannes", "Engorgements des restaurants de Golfe-Juan", "Réseaux anciens du centre historique"],
    nearbyAreas: ["Antibes", "Cannes", "Le Cannet", "Biot"]
  },
  {
    slug: "antibes",
    name: "Antibes",
    postalCode: "06600",
    metaTitle: "Débouchage Antibes 06600 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Antibes (06600). Intervention vieil Antibes, Juan-les-Pins, Cap d'Antibes. Canalisations bouchées ? Travail garanti. Devis gratuit.",
    description: "Antibes, deuxième ville des Alpes-Maritimes, allie patrimoine historique et modernité. Du vieil Antibes au technopole de Sophia-Antipolis, nous intervenons sur toute la commune et ses quartiers emblématiques.",
    quartiers: ["Vieil Antibes", "Juan-les-Pins", "Cap d'Antibes", "La Fontonne", "Les Semboules", "Sophia-Antipolis"],
    localInfo: "Antibes concentre une grande diversité de besoins : yachts du port Vauban, restaurants du vieil Antibes, entreprises de Sophia-Antipolis. Notre polyvalence nous permet de répondre à toutes ces demandes.",
    typicalProblems: ["Canalisations des yachts au Port Vauban", "Réseaux anciens du vieil Antibes", "Bacs à graisse des restaurants", "Évacuations des entreprises de Sophia"],
    nearbyAreas: ["Juan-les-Pins", "Vallauris", "Biot", "Villeneuve-Loubet"]
  },
  {
    slug: "golfe-juan",
    name: "Golfe-Juan",
    postalCode: "06220",
    metaTitle: "Débouchage Golfe-Juan 06220 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Golfe-Juan (06220). Intervention port, plages, centre. WC, évier bouchés ? Week-ends et jours fériés. Travail garanti. Devis gratuit.",
    description: "Golfe-Juan, station balnéaire où Napoléon débarqua en 1815, est un quartier de Vallauris tourné vers la mer. Entre port de plaisance et plages de sable fin, nous intervenons pour tous les besoins en débouchage.",
    quartiers: ["Port de Golfe-Juan", "Plages", "Centre", "Tétou", "Les Flots Bleus"],
    localInfo: "Station balnéaire très fréquentée en été, Golfe-Juan voit sa population tripler pendant la saison. Nous assurons un service renforcé pendant cette période pour répondre aux urgences des vacanciers.",
    typicalProblems: ["Canalisations des restaurants de plage", "Engorgements liés au sable", "Évacuations des locations saisonnières", "Bateaux de plaisance du port"],
    nearbyAreas: ["Vallauris", "Juan-les-Pins", "Cannes", "Antibes"]
  },
  {
    slug: "juan-les-pins",
    name: "Juan-les-Pins",
    postalCode: "06160",
    metaTitle: "Débouchage Juan-les-Pins 06160 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Juan-les-Pins (06160). Intervention centre, plages, pinède. Canalisations bouchées ? Week-ends et jours fériés. Devis gratuit.",
    description: "Juan-les-Pins, station balnéaire mythique de la Côte d'Azur, est célèbre pour ses plages, sa vie nocturne et son festival de jazz. Nous intervenons rapidement auprès des hôtels, restaurants et résidences de la station.",
    quartiers: ["Centre", "Pinède", "Plages", "Gould", "Belles Rives", "La Gallice"],
    localInfo: "Haut lieu de la vie nocturne azuréenne, Juan-les-Pins compte de nombreux bars, restaurants et discothèques. Nos interventions en urgence permettent à ces établissements de maintenir leur activité.",
    typicalProblems: ["Bacs à graisse des restaurants et discothèques", "Canalisations des hôtels de bord de mer", "Engorgements liés au sable", "Évacuations des résidences de vacances"],
    nearbyAreas: ["Antibes", "Golfe-Juan", "Vallauris", "Cap d'Antibes"]
  },
  {
    slug: "le-suquet",
    name: "Le Suquet",
    postalCode: "06400",
    metaTitle: "Débouchage Le Suquet Cannes 06400 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage au Suquet, vieux Cannes. Intervention ruelles historiques, restaurants. Canalisations anciennes ? Travail garanti. Devis gratuit.",
    description: "Le Suquet, quartier historique de Cannes perché sur sa colline, est le cœur médiéval de la ville avec ses ruelles pavées et ses maisons anciennes. Nos équipements adaptés permettent d'intervenir dans ce dédale pittoresque.",
    quartiers: ["Vieux Cannes", "Colline du Suquet", "Rue Saint-Antoine", "Place du Suquet", "Port Le Vieux"],
    localInfo: "Le Suquet possède les canalisations les plus anciennes de Cannes, certaines datant de plusieurs siècles. Notre expertise en réseaux anciens et notre matériel compact sont essentiels pour ce quartier.",
    typicalProblems: ["Canalisations en terre cuite centenaires", "Accès difficiles dans les ruelles étroites", "Refoulements dans les restaurants du port", "Réseaux vétustes des maisons anciennes"],
    nearbyAreas: ["Cannes Centre", "La Croisette", "Le Port", "Californie"]
  },
  {
    slug: "california",
    name: "California",
    postalCode: "06400",
    metaTitle: "Débouchage Californie Cannes 06400 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage quartier Californie à Cannes. Intervention villas de luxe, résidences. Canalisations bouchées ? Discrétion garantie. Devis gratuit.",
    description: "La Californie, quartier résidentiel huppé sur les hauteurs de Cannes, abrite de somptueuses villas avec vue mer. Nous assurons un service premium et discret pour cette clientèle exigeante.",
    quartiers: ["Californie", "Super Cannes", "La Croix des Gardes", "Avenue de la Californie"],
    localInfo: "Quartier des villas de luxe avec piscines et jardins paysagers, la Californie nécessite des interventions soignées. Nous travaillons en coordination avec les gardiens et conciergeries.",
    typicalProblems: ["Évacuations des piscines à débordement", "Canalisations des villas de prestige", "Pompes de relevage des sous-sols", "Racines des jardins méditerranéens"],
    nearbyAreas: ["Cannes Centre", "Le Cannet", "Vallauris Super Cannes", "Le Suquet"]
  },
  {
    slug: "pezou",
    name: "Pezou",
    postalCode: "06400",
    metaTitle: "Débouchage Pezou Cannes 06400 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage quartier Pezou à Cannes. Intervention résidences, villas. WC, évier bouchés ? Week-ends et jours fériés. Devis gratuit.",
    description: "Pezou, quartier résidentiel de Cannes situé entre le centre-ville et La Bocca, est un secteur paisible avec des résidences et pavillons. Nous intervenons rapidement pour tous les problèmes de canalisation.",
    quartiers: ["Pezou", "Avenue Maurice Chevalier", "Les Vallergues", "La Roubine"],
    localInfo: "Quartier familial avec de nombreuses copropriétés, Pezou nécessite des interventions rapides pour minimiser la gêne des résidents. Nous travaillons régulièrement avec les syndics du secteur.",
    typicalProblems: ["Engorgements des copropriétés", "Canalisations des pavillons des années 60-70", "Racines dans les évacuations", "WC et éviers bouchés"],
    nearbyAreas: ["Cannes Centre", "La Bocca", "Le Cannet", "Ranguin"]
  },
  {
    slug: "peymeinade",
    name: "Peymeinade",
    postalCode: "06530",
    metaTitle: "Débouchage Peymeinade 06530 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Peymeinade (06530). Intervention village, zones résidentielles. Fosses septiques, canalisations bouchées. Devis gratuit.",
    description: "Peymeinade, commune résidentielle de l'arrière-pays grassois, est un village provençal paisible entre mer et montagne. Nous intervenons dans tout le village et ses quartiers résidentiels.",
    quartiers: ["Centre-village", "Les Jasmins", "Le Plan", "Les Music", "La Chapelle"],
    localInfo: "Peymeinade est une commune résidentielle avec de nombreuses maisons individuelles dotées de fosses septiques. Notre expertise en assainissement non collectif est très appréciée des habitants.",
    typicalProblems: ["Fosses septiques des maisons individuelles", "Canalisations des vieilles maisons du village", "Racines dans les évacuations", "Engorgements après fortes pluies"],
    nearbyAreas: ["Grasse", "Cabris", "Spéracèdes", "Le Tignet"]
  },
  {
    slug: "mouans-sartoux",
    name: "Mouans-Sartoux",
    postalCode: "06370",
    metaTitle: "Débouchage Mouans-Sartoux 06370 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Mouans-Sartoux (06370). Intervention centre, zones pavillonnaires. WC, évier bouchés ? Travail garanti. Devis gratuit.",
    description: "Mouans-Sartoux, commune dynamique entre Grasse et Cannes, est connue pour son festival du livre et son engagement écologique. Nous intervenons dans tous les quartiers de cette ville verte.",
    quartiers: ["Centre-ville", "Le Château", "Les Music", "Saint-Donat", "La Frayère", "Plan Sarrain"],
    localInfo: "Mouans-Sartoux est une ville engagée dans l'écologie avec une restauration scolaire 100% bio. Nous partageons ces valeurs en proposant des solutions de débouchage respectueuses de l'environnement.",
    typicalProblems: ["Canalisations des maisons individuelles", "Copropriétés du centre-ville", "Fosses septiques des zones rurales", "Racines des jardins"],
    nearbyAreas: ["Mougins", "Grasse", "Pégomas", "Le Cannet"]
  },
  {
    slug: "nice",
    name: "Nice",
    postalCode: "06000",
    metaTitle: "Débouchage Nice 06000 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Nice (06000). Intervention Vieux-Nice, Cimiez, Promenade des Anglais, Port. WC, évier bouchés ? Devis gratuit.",
    description: "Nice, capitale de la Côte d'Azur et 5ème ville de France, allie charme méditerranéen et dynamisme urbain. De la Promenade des Anglais au Vieux-Nice, nous intervenons dans tous les quartiers de la ville.",
    quartiers: ["Vieux-Nice", "Promenade des Anglais", "Cimiez", "Le Port", "Libération", "Riquier", "Saint-Roch", "Arenas"],
    localInfo: "Nice possède un patrimoine architectural exceptionnel avec des immeubles anciens au Vieux-Nice et des constructions modernes sur le front de mer. Notre expertise nous permet d'intervenir sur tous types de canalisations.",
    typicalProblems: ["Immeubles anciens du Vieux-Nice", "Calcaire important", "Restaurants et hôtels", "Copropriétés du centre"],
    nearbyAreas: ["Cagnes-sur-Mer", "Saint-Laurent-du-Var", "Villefranche-sur-Mer", "Menton"]
  },
  {
    slug: "cagnes-sur-mer",
    name: "Cagnes-sur-Mer",
    postalCode: "06800",
    metaTitle: "Débouchage Cagnes-sur-Mer 06800 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Cagnes-sur-Mer (06800). Intervention Haut-de-Cagnes, Cros-de-Cagnes, Hippodrome. WC, évier bouchés ? Devis gratuit.",
    description: "Cagnes-sur-Mer, cité des peintres immortalisée par Renoir, offre un cadre de vie exceptionnel entre village médiéval et bord de mer. Nous intervenons du Haut-de-Cagnes aux plages du Cros-de-Cagnes.",
    quartiers: ["Haut-de-Cagnes", "Cros-de-Cagnes", "Centre-ville", "Hippodrome", "Val Fleuri", "Les Vespins"],
    localInfo: "La cité des peintres compte un village médiéval avec des ruelles étroites et une station balnéaire moderne. Notre équipement compact permet d'intervenir partout.",
    typicalProblems: ["Village médiéval ancien", "Sable des plages", "Restaurants bord de mer", "Copropriétés de l'Hippodrome"],
    nearbyAreas: ["Nice", "Saint-Laurent-du-Var", "Villeneuve-Loubet", "Vence"]
  },
  {
    slug: "menton",
    name: "Menton",
    postalCode: "06500",
    metaTitle: "Débouchage Menton 06500 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Menton (06500), perle de la France. Intervention vieille ville, Garavan, Carnolès. WC, évier bouchés ? Devis gratuit.",
    description: "Menton, la 'perle de la France' aux portes de l'Italie, est réputée pour ses jardins exceptionnels et son climat unique. Nous intervenons de la vieille ville aux quartiers résidentiels de Garavan.",
    quartiers: ["Vieille ville", "Garavan", "Carnolès", "Centre-ville", "Madone", "Borrigo"],
    localInfo: "Menton possède un patrimoine architectural exceptionnel avec ses villas Belle Époque et sa vieille ville pittoresque. Notre expertise permet d'intervenir avec précaution sur les réseaux anciens.",
    typicalProblems: ["Vieille ville historique", "Calcaire important", "Résidences seniors", "Jardins et villas de Garavan"],
    nearbyAreas: ["Monaco", "Roquebrune-Cap-Martin", "Beausoleil", "Vintimille"]
  },
  {
    slug: "saint-laurent-du-var",
    name: "Saint-Laurent-du-Var",
    postalCode: "06700",
    metaTitle: "Débouchage Saint-Laurent-du-Var 06700 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Saint-Laurent-du-Var (06700). Intervention Cap 3000, Port, centre-ville. WC, évier bouchés ? Devis gratuit.",
    description: "Saint-Laurent-du-Var, ville dynamique à l'embouchure du Var, combine zones commerciales, port de plaisance et quartiers résidentiels. Du Cap 3000 au front de mer, nous couvrons toute la commune.",
    quartiers: ["Cap 3000", "Port Saint-Laurent", "Centre-ville", "Les Pugets", "Montaleigne", "Front de mer"],
    localInfo: "Saint-Laurent-du-Var est une ville commerciale dynamique avec le centre commercial Cap 3000 et un port de plaisance actif. Nous intervenons régulièrement pour les commerces et les restaurants.",
    typicalProblems: ["Commerces Cap 3000", "Sable du Var", "Restaurants du port", "Résidences bord de mer"],
    nearbyAreas: ["Nice", "Cagnes-sur-Mer", "Villeneuve-Loubet", "Carros"]
  },
  {
    slug: "villeneuve-loubet",
    name: "Villeneuve-Loubet",
    postalCode: "06270",
    metaTitle: "Débouchage Villeneuve-Loubet 06270 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Villeneuve-Loubet (06270). Intervention Marina Baie des Anges, village, plage. WC, évier bouchés ? Devis gratuit.",
    description: "Villeneuve-Loubet, entre Nice et Antibes, est célèbre pour sa Marina Baie des Anges et son patrimoine culinaire. Nous intervenons du village provençal à la station balnéaire moderne.",
    quartiers: ["Marina Baie des Anges", "Village", "Villeneuve-Plage", "Hauts de Vaugrenier", "Les Maurettes", "Parc du Loup"],
    localInfo: "Villeneuve-Loubet possède une architecture unique avec la Marina Baie des Anges et un village provençal authentique. Notre expertise nous permet d'intervenir sur tous types d'installations.",
    typicalProblems: ["Marina architecture spécifique", "Village ancien", "Restaurants gastronomiques", "Locations vacances"],
    nearbyAreas: ["Cagnes-sur-Mer", "Antibes", "Biot", "Valbonne"]
  },
  {
    slug: "monaco",
    name: "Monaco",
    postalCode: "98000",
    metaTitle: "Débouchage Monaco 98000 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Monaco (98000). Service premium discret. Intervention Monte-Carlo, Fontvieille, Larvotto, Port Hercule. Appelez le 07 44 87 87 63",
    description: "Monaco, principauté prestigieuse sur la Côte d'Azur, exige un service de débouchage à la hauteur de son standing. De Monte-Carlo au Port Hercule, nous intervenons avec la plus grande discrétion.",
    quartiers: ["Monte-Carlo", "Fontvieille", "Larvotto", "Port Hercule", "Monaco-Ville", "La Condamine", "Les Moneghetti", "Jardin Exotique"],
    localInfo: "Monaco, avec ses résidences de prestige et ses établissements de luxe, nécessite un service irréprochable. Nous intervenons avec discrétion et professionnalisme auprès des particuliers, hôtels et yachts.",
    typicalProblems: ["Résidences de luxe", "Palaces et hôtels", "Restaurants étoilés", "Yachts Port Hercule"],
    nearbyAreas: ["Menton", "Beausoleil", "Roquebrune-Cap-Martin", "Cap-d'Ail"]
  },
  {
    slug: "vence",
    name: "Vence",
    postalCode: "06140",
    metaTitle: "Débouchage Vence 06140 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Vence (06140). Intervention cité historique, Saint-Martin, Col de Vence. WC, évier bouchés ? Devis gratuit.",
    description: "Vence, cité des arts au pied des Baous, est célèbre pour sa chapelle Matisse et son patrimoine historique. De la vieille ville aux hauteurs du Col de Vence, nous intervenons partout.",
    quartiers: ["Cité historique", "Saint-Martin", "La Sine", "Les Parcs", "Col de Vence", "Le Malvan"],
    localInfo: "Vence possède un riche patrimoine avec sa vieille ville médiévale et ses nombreuses villas sur les collines. Notre expertise nous permet d'intervenir sur tous types de canalisations.",
    typicalProblems: ["Canalisations cité historique", "Fosses septiques villas", "Calcaire important", "Restaurants du village"],
    nearbyAreas: ["Cagnes-sur-Mer", "Saint-Paul-de-Vence", "Tourrettes-sur-Loup", "La Gaude"]
  },
  {
    slug: "villefranche-sur-mer",
    name: "Villefranche-sur-Mer",
    postalCode: "06230",
    metaTitle: "Débouchage Villefranche-sur-Mer 06230 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Villefranche-sur-Mer (06230). Intervention vieille ville, port, citadelle. WC, évier bouchés ? Devis gratuit.",
    description: "Villefranche-sur-Mer, avec sa rade magnifique et sa vieille ville colorée, est l'un des joyaux de la Côte d'Azur. Nous intervenons du port de la Darse à la citadelle.",
    quartiers: ["Vieille ville", "Port de la Darse", "Citadelle", "Moyenne Corniche", "Basse Corniche", "Mont Alban"],
    localInfo: "La vieille ville de Villefranche possède des ruelles étroites et des bâtiments historiques avec des canalisations anciennes. Notre équipement compact permet d'intervenir partout.",
    typicalProblems: ["Ruelles étroites vieille ville", "Restaurants du port", "Villas vue mer", "Immeubles anciens"],
    nearbyAreas: ["Nice", "Beaulieu-sur-Mer", "Saint-Jean-Cap-Ferrat", "Èze"]
  },
  {
    slug: "beaulieu-sur-mer",
    name: "Beaulieu-sur-Mer",
    postalCode: "06310",
    metaTitle: "Débouchage Beaulieu-sur-Mer 06310 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Beaulieu-sur-Mer (06310). Intervention port, centre, villas Belle Époque. WC, évier bouchés ? Devis gratuit.",
    description: "Beaulieu-sur-Mer, la 'petite Afrique' au climat exceptionnel, est réputée pour ses villas Belle Époque et son port de plaisance. Service premium pour cette station balnéaire de prestige.",
    quartiers: ["Port de plaisance", "Centre-ville", "Petite Afrique", "Boulevard Marinoni", "Les Fourmis", "Mont Leuze"],
    localInfo: "Beaulieu-sur-Mer compte de nombreuses villas de prestige datant de la Belle Époque. Notre expertise nous permet d'intervenir avec soin sur ces installations historiques.",
    typicalProblems: ["Villas Belle Époque", "Hôtels de luxe", "Port de plaisance", "Résidences seniors"],
    nearbyAreas: ["Saint-Jean-Cap-Ferrat", "Villefranche-sur-Mer", "Èze", "Monaco"]
  },
  {
    slug: "saint-jean-cap-ferrat",
    name: "Saint-Jean-Cap-Ferrat",
    postalCode: "06230",
    metaTitle: "Débouchage Saint-Jean-Cap-Ferrat 06230 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Saint-Jean-Cap-Ferrat (06230). Service premium discret. Intervention villas prestige, port. Devis gratuit.",
    description: "Saint-Jean-Cap-Ferrat, presqu'île la plus exclusive de la Côte d'Azur, abrite les villas les plus prestigieuses au monde. Service ultra-discret pour une clientèle exigeante.",
    quartiers: ["Village", "Port", "Pointe de Saint-Hospice", "Passable", "Paloma", "Villa Ephrussi"],
    localInfo: "Saint-Jean-Cap-Ferrat concentre les plus belles propriétés de la Riviera. Nous intervenons avec la plus grande discrétion auprès des propriétaires et de leurs gardiens.",
    typicalProblems: ["Villas ultra-prestige", "Piscines à débordement", "Jardins méditerranéens", "Propriétés sécurisées"],
    nearbyAreas: ["Beaulieu-sur-Mer", "Villefranche-sur-Mer", "Nice", "Monaco"]
  },
  {
    slug: "biot",
    name: "Biot",
    postalCode: "06410",
    metaTitle: "Débouchage Biot 06410 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Biot (06410). Intervention village, Sophia-Antipolis, verreries. WC, évier bouchés ? Devis gratuit.",
    description: "Biot, village des verriers entre tradition et high-tech, allie patrimoine artisanal et technopole de Sophia-Antipolis. Nous intervenons du village perché aux entreprises de la technopole.",
    quartiers: ["Village historique", "Sophia-Antipolis", "Les Verriers", "Saint-Julien", "La Romaine", "Les Combes"],
    localInfo: "Biot combine un village médiéval avec ses ateliers de verrerie et le pôle technologique de Sophia-Antipolis. Notre polyvalence nous permet de répondre à tous les besoins.",
    typicalProblems: ["Village ancien", "Entreprises Sophia", "Ateliers verrerie", "Résidences collines"],
    nearbyAreas: ["Antibes", "Villeneuve-Loubet", "Valbonne", "Sophia-Antipolis"]
  },
  {
    slug: "carros",
    name: "Carros",
    postalCode: "06510",
    metaTitle: "Débouchage Carros 06510 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Carros (06510). Intervention village, zone industrielle, Le Plan. WC, évier bouchés ? Devis gratuit.",
    description: "Carros, entre village perché et zone industrielle dynamique, offre un contraste unique. Du vieux village médiéval à la zone d'activités, nous couvrons toute la commune.",
    quartiers: ["Carros Village", "Le Plan de Carros", "Zone industrielle", "Les Plans", "La Manda", "Les Ollières"],
    localInfo: "Carros possède l'une des plus grandes zones industrielles des Alpes-Maritimes. Nous intervenons régulièrement auprès des entreprises et des particuliers du secteur.",
    typicalProblems: ["Zone industrielle", "Village médiéval", "Entreprises", "Résidences Le Plan"],
    nearbyAreas: ["Nice", "Saint-Laurent-du-Var", "Gattières", "Le Broc"]
  },
  {
    slug: "roquebrune-cap-martin",
    name: "Roquebrune-Cap-Martin",
    postalCode: "06190",
    metaTitle: "Débouchage Roquebrune-Cap-Martin 06190 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage à Roquebrune-Cap-Martin (06190). Intervention village, Cap Martin, Carnolès. WC, évier bouchés ? Devis gratuit.",
    description: "Roquebrune-Cap-Martin, du village médiéval perché au Cap Martin prisé des célébrités, offre des panoramas exceptionnels. Service premium pour cette commune de prestige.",
    quartiers: ["Roquebrune Village", "Cap Martin", "Carnolès", "Cabbé", "Bon Voyage", "Saint-Roman"],
    localInfo: "Roquebrune-Cap-Martin allie un village perché millénaire et un cap résidentiel très prisé. Nous intervenons avec discrétion dans ces deux environnements distincts.",
    typicalProblems: ["Village perché ancien", "Villas Cap Martin", "Résidences Carnolès", "Accès difficiles"],
    nearbyAreas: ["Monaco", "Menton", "Beausoleil", "Cap-d'Ail"]
  },
  {
    slug: "valbonne",
    name: "Valbonne",
    postalCode: "06560",
    metaTitle: "Débouchage Canalisation Valbonne 06560 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Valbonne (06560). Intervention village, Sophia-Antipolis. WC, évier bouchés ? Devis gratuit.",
    description: "Valbonne, village provençal authentique aux portes de Sophia-Antipolis, allie charme historique et modernité technologique. Nous intervenons du village médiéval aux zones d'activités.",
    quartiers: ["Village historique", "Sophia-Antipolis", "Garbejaire", "Les Lucioles", "Les Bouillides", "Saint-Bernard"],
    localInfo: "Valbonne accueille une partie de Sophia-Antipolis, première technopole d'Europe. Notre expertise nous permet d'intervenir aussi bien dans le village ancien que dans les entreprises high-tech.",
    typicalProblems: ["Village ancien", "Entreprises Sophia", "Résidences standing", "Restaurants du village"],
    nearbyAreas: ["Biot", "Mougins", "Antibes", "Grasse"]
  },
  {
    slug: "eze",
    name: "Èze",
    postalCode: "06360",
    metaTitle: "Débouchage Canalisation Èze 06360 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Èze (06360). Intervention village perché, Èze-bord-de-mer. WC, évier bouchés ? Devis gratuit.",
    description: "Èze, village médiéval perché entre mer et montagne, offre des panoramas exceptionnels. Du village historique à Èze-bord-de-mer, nous intervenons avec du matériel adapté aux accès difficiles.",
    quartiers: ["Èze Village", "Èze-bord-de-mer", "Col d'Èze", "La Turbie", "Grande Corniche"],
    localInfo: "Le village d'Èze, perché à 429m, possède des ruelles étroites et des canalisations anciennes. Notre équipement compact permet d'intervenir dans les accès les plus difficiles.",
    typicalProblems: ["Village perché accès difficile", "Canalisations anciennes", "Hôtels de luxe", "Restaurants panoramiques"],
    nearbyAreas: ["Villefranche-sur-Mer", "Beaulieu-sur-Mer", "La Turbie", "Cap-d'Ail"]
  },
  {
    slug: "la-turbie",
    name: "La Turbie",
    postalCode: "06320",
    metaTitle: "Débouchage Canalisation La Turbie 06320 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à La Turbie (06320). Intervention village, Trophée des Alpes. WC, évier bouchés ? Devis gratuit.",
    description: "La Turbie, dominée par le majestueux Trophée des Alpes, est un village historique surplombant Monaco. Nous intervenons dans ce village pittoresque aux vues imprenables.",
    quartiers: ["Village", "Trophée des Alpes", "La Grande Corniche", "Les Serres"],
    localInfo: "La Turbie offre une vue spectaculaire sur Monaco et la Méditerranée. Ses maisons anciennes nécessitent une expertise particulière pour les interventions de débouchage.",
    typicalProblems: ["Maisons anciennes", "Accès escarpés", "Canalisations vétustes", "Villas vue mer"],
    nearbyAreas: ["Monaco", "Èze", "Beausoleil", "Cap-d'Ail"]
  },
  {
    slug: "beausoleil",
    name: "Beausoleil",
    postalCode: "06240",
    metaTitle: "Débouchage Canalisation Beausoleil 06240 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Beausoleil (06240). Intervention frontière Monaco. WC, évier bouchés ? Devis gratuit.",
    description: "Beausoleil, ville française aux portes de Monaco, bénéficie d'une situation exceptionnelle sur les hauteurs de la Principauté. Nous intervenons dans tous les quartiers de cette commune dynamique.",
    quartiers: ["Centre-ville", "Riviera", "Ténao", "Moneghetti", "Les Moulins"],
    localInfo: "Beausoleil partage sa frontière avec Monaco et connaît une forte densité urbaine. Nous intervenons rapidement dans les nombreux immeubles et résidences de la commune.",
    typicalProblems: ["Immeubles anciens", "Forte densité urbaine", "Copropriétés", "Proximité Monaco"],
    nearbyAreas: ["Monaco", "La Turbie", "Roquebrune-Cap-Martin", "Menton"]
  },
  {
    slug: "cap-d-ail",
    name: "Cap-d'Ail",
    postalCode: "06320",
    metaTitle: "Débouchage Canalisation Cap-d'Ail 06320 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Cap-d'Ail (06320). Intervention plages, villas vue mer. WC, évier bouchés ? Devis gratuit.",
    description: "Cap-d'Ail, station balnéaire élégante aux portes de Monaco, est réputée pour ses criques et son patrimoine Belle Époque. Nous intervenons avec discrétion dans ce cadre prestigieux.",
    quartiers: ["Centre", "Plage Mala", "Pointe des Douaniers", "Marquet", "La Pinède"],
    localInfo: "Cap-d'Ail compte de nombreuses villas Belle Époque et résidences de standing. Notre service premium s'adapte aux exigences de cette clientèle.",
    typicalProblems: ["Villas Belle Époque", "Résidences de luxe", "Accès plages difficiles", "Canalisations anciennes"],
    nearbyAreas: ["Monaco", "Èze", "Beaulieu-sur-Mer", "La Turbie"]
  },
  {
    slug: "theoule-sur-mer",
    name: "Théoule-sur-Mer",
    postalCode: "06590",
    metaTitle: "Débouchage Canalisation Théoule-sur-Mer 06590 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Théoule-sur-Mer (06590). Intervention Miramar, Port la Galère. WC, évier bouchés ? Devis gratuit.",
    description: "Théoule-sur-Mer, joyau de l'Estérel aux eaux turquoise, est une station balnéaire prisée entre Cannes et Saint-Raphaël. Nous intervenons dans ce cadre naturel exceptionnel.",
    quartiers: ["Centre", "Miramar", "Port la Galère", "Le Trayas", "La Figueirette"],
    localInfo: "Théoule-sur-Mer est nichée dans le massif de l'Estérel avec des accès parfois difficiles. Notre équipement adapté permet d'intervenir dans toutes les situations.",
    typicalProblems: ["Villas vue mer", "Accès montagneux", "Résidences Port la Galère", "Locations saisonnières"],
    nearbyAreas: ["Mandelieu-la-Napoule", "Cannes", "Saint-Raphaël", "Fréjus"]
  },
  {
    slug: "tourrettes-sur-loup",
    name: "Tourrettes-sur-Loup",
    postalCode: "06140",
    metaTitle: "Débouchage Canalisation Tourrettes-sur-Loup 06140 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Tourrettes-sur-Loup (06140). Cité des violettes. WC, évier bouchés ? Devis gratuit.",
    description: "Tourrettes-sur-Loup, la cité des violettes, est un village médiéval perché typique de l'arrière-pays niçois. Nous intervenons dans ce cadre authentique préservé.",
    quartiers: ["Village médiéval", "Les Courmettes", "Pont du Loup", "La Moulière"],
    localInfo: "Tourrettes-sur-Loup est célèbre pour sa culture de violettes et son village fortifié. Nos techniciens sont habitués aux interventions dans les villages perchés.",
    typicalProblems: ["Village médiéval", "Ruelles étroites", "Maisons anciennes", "Fosses septiques"],
    nearbyAreas: ["Vence", "Saint-Paul-de-Vence", "Grasse", "Cagnes-sur-Mer"]
  },
  {
    slug: "saint-paul-de-vence",
    name: "Saint-Paul-de-Vence",
    postalCode: "06570",
    metaTitle: "Débouchage Canalisation Saint-Paul-de-Vence 06570 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Saint-Paul-de-Vence (06570). Village d'artistes. WC, évier bouchés ? Devis gratuit.",
    description: "Saint-Paul-de-Vence, village d'artistes mondialement célèbre, est un joyau médiéval perché au-dessus de la Côte d'Azur. Service discret pour ce village d'exception.",
    quartiers: ["Village fortifié", "Fondation Maeght", "Les Gardettes", "La Colle-sur-Loup"],
    localInfo: "Saint-Paul-de-Vence accueille galeries d'art, hôtels de charme et restaurants gastronomiques. Nous intervenons avec la discrétion requise dans ce cadre prestigieux.",
    typicalProblems: ["Village fortifié", "Galeries et restaurants", "Hôtels de charme", "Canalisations historiques"],
    nearbyAreas: ["Vence", "Cagnes-sur-Mer", "Tourrettes-sur-Loup", "La Colle-sur-Loup"]
  },
  {
    slug: "la-colle-sur-loup",
    name: "La Colle-sur-Loup",
    postalCode: "06480",
    metaTitle: "Débouchage Canalisation La Colle-sur-Loup 06480 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à La Colle-sur-Loup (06480). WC, évier bouchés ? Intervention rapide. Devis gratuit.",
    description: "La Colle-sur-Loup, commune résidentielle entre mer et montagne, offre un cadre de vie privilégié à proximité de Saint-Paul-de-Vence. Nous intervenons dans tous les quartiers.",
    quartiers: ["Centre", "Les Plans", "Pont du Loup", "La Gaude"],
    localInfo: "La Colle-sur-Loup est une commune résidentielle appréciée pour son calme et sa proximité avec la côte. Nous intervenons rapidement pour tous vos problèmes de canalisation.",
    typicalProblems: ["Villas résidentielles", "Maisons individuelles", "Fosses septiques", "Jardins avec racines"],
    nearbyAreas: ["Saint-Paul-de-Vence", "Vence", "Cagnes-sur-Mer", "Villeneuve-Loubet"]
  },
  {
    slug: "la-gaude",
    name: "La Gaude",
    postalCode: "06610",
    metaTitle: "Débouchage Canalisation La Gaude 06610 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à La Gaude (06610). WC, évier bouchés ? Intervention rapide. Devis gratuit.",
    description: "La Gaude, village perché dominant la vallée du Var, est une commune résidentielle prisée. Nous intervenons du vieux village aux quartiers résidentiels modernes.",
    quartiers: ["Village", "IBM", "Les Plans", "Saint-Laurent"],
    localInfo: "La Gaude accueille notamment un centre IBM historique. Nous intervenons aussi bien auprès des entreprises que des particuliers de cette commune verdoyante.",
    typicalProblems: ["Village ancien", "Villas avec jardins", "Entreprises", "Fosses septiques"],
    nearbyAreas: ["Saint-Jeannet", "Vence", "Cagnes-sur-Mer", "Saint-Laurent-du-Var"]
  },
  {
    slug: "saint-jeannet",
    name: "Saint-Jeannet",
    postalCode: "06640",
    metaTitle: "Débouchage Canalisation Saint-Jeannet 06640 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Saint-Jeannet (06640). Village du Baou. WC, évier bouchés ? Devis gratuit.",
    description: "Saint-Jeannet, au pied du célèbre Baou, est un village provençal authentique prisé des grimpeurs. Nous intervenons dans ce cadre naturel exceptionnel.",
    quartiers: ["Village", "Le Baou", "Les Plans", "Castellet"],
    localInfo: "Saint-Jeannet est dominé par son Baou, falaise calcaire emblématique. Le village ancien possède des canalisations nécessitant une expertise particulière.",
    typicalProblems: ["Village ancien", "Maisons en pierre", "Fosses septiques", "Accès difficiles"],
    nearbyAreas: ["La Gaude", "Vence", "Gattières", "Carros"]
  },
  {
    slug: "gattieres",
    name: "Gattières",
    postalCode: "06510",
    metaTitle: "Débouchage Canalisation Gattières 06510 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Gattières (06510). Village perché. WC, évier bouchés ? Devis gratuit.",
    description: "Gattières, village perché surplombant la vallée du Var, offre un cadre de vie paisible. Nous intervenons du vieux village aux zones résidentielles.",
    quartiers: ["Village", "Plan du Var", "Les Vallières", "Saint-Pierre"],
    localInfo: "Gattières est un village authentique avec vue panoramique sur les Alpes et la mer. Nos techniciens connaissent bien les spécificités des villages perchés.",
    typicalProblems: ["Village perché", "Canalisations anciennes", "Fosses septiques", "Résidences collines"],
    nearbyAreas: ["Carros", "Le Broc", "Saint-Jeannet", "Nice"]
  },
  {
    slug: "le-broc",
    name: "Le Broc",
    postalCode: "06510",
    metaTitle: "Débouchage Canalisation Le Broc 06510 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation au Broc (06510). Village perché. WC, évier bouchés ? Devis gratuit.",
    description: "Le Broc, village médiéval perché au-dessus de la vallée du Var, est une commune paisible du moyen-pays niçois. Nous intervenons avec du matériel adapté.",
    quartiers: ["Village", "Plan du Broc", "Les Baumettes"],
    localInfo: "Le Broc domine la confluence du Var et de l'Estéron. Ce village préservé possède un patrimoine architectural nécessitant des interventions soignées.",
    typicalProblems: ["Village médiéval", "Accès difficiles", "Maisons anciennes", "Fosses septiques"],
    nearbyAreas: ["Carros", "Gattières", "Bouyon", "Gilette"]
  },
  {
    slug: "aspremont",
    name: "Aspremont",
    postalCode: "06790",
    metaTitle: "Débouchage Canalisation Aspremont 06790 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Aspremont (06790). Village perché Nice. WC, évier bouchés ? Devis gratuit.",
    description: "Aspremont, village perché à 15 minutes de Nice, offre un panorama exceptionnel sur la Côte d'Azur. Nous intervenons dans ce cadre provençal authentique.",
    quartiers: ["Village", "Les Cluots", "Plan d'Aspremont"],
    localInfo: "Aspremont est un village perché typique avec une vue imprenable sur Nice et la Baie des Anges. Nos équipes sont expertes des interventions en village ancien.",
    typicalProblems: ["Village perché", "Canalisations anciennes", "Villas collines", "Fosses septiques"],
    nearbyAreas: ["Nice", "Colomars", "Castagniers", "Tourrette-Levens"]
  },
  {
    slug: "colomars",
    name: "Colomars",
    postalCode: "06670",
    metaTitle: "Débouchage Canalisation Colomars 06670 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Colomars (06670). Proche Nice. WC, évier bouchés ? Devis gratuit.",
    description: "Colomars, commune résidentielle des collines niçoises, offre un cadre de vie verdoyant à proximité de Nice. Intervention rapide pour tous vos problèmes de canalisation.",
    quartiers: ["Village", "La Sirole", "Les Plans", "Saint-Pierre"],
    localInfo: "Colomars bénéficie d'une situation privilégiée entre Nice et l'arrière-pays. Nous intervenons rapidement dans cette commune résidentielle prisée.",
    typicalProblems: ["Villas avec jardins", "Fosses septiques", "Résidences collines", "Racines arbres"],
    nearbyAreas: ["Nice", "Aspremont", "Castagniers", "Saint-Martin-du-Var"]
  },
  {
    slug: "castagniers",
    name: "Castagniers",
    postalCode: "06670",
    metaTitle: "Débouchage Canalisation Castagniers 06670 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Castagniers (06670). Arrière-pays niçois. WC, évier bouchés ? Devis gratuit.",
    description: "Castagniers, village de l'arrière-pays niçois, est une commune résidentielle appréciée pour son calme et sa nature préservée. Intervention professionnelle garantie.",
    quartiers: ["Village", "Plan de Castagniers", "Les Moulins"],
    localInfo: "Castagniers offre un cadre champêtre à proximité de Nice. De nombreuses maisons individuelles avec jardins nécessitent notre expertise en assainissement.",
    typicalProblems: ["Maisons individuelles", "Fosses septiques", "Jardins et racines", "Canalisations rurales"],
    nearbyAreas: ["Colomars", "Aspremont", "Nice", "Levens"]
  },
  {
    slug: "tourrette-levens",
    name: "Tourrette-Levens",
    postalCode: "06690",
    metaTitle: "Débouchage Canalisation Tourrette-Levens 06690 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Tourrette-Levens (06690). WC, évier bouchés ? Devis gratuit.",
    description: "Tourrette-Levens, au carrefour des vallées du Paillon, est une commune dynamique de l'arrière-pays niçois. Intervention rapide dans tous les quartiers.",
    quartiers: ["Village", "Les Plans", "Saint-Pancrace", "Le Collet"],
    localInfo: "Tourrette-Levens est une commune en pleine expansion avec un mélange de constructions anciennes et récentes. Nous adaptons nos interventions à chaque situation.",
    typicalProblems: ["Village ancien", "Constructions neuves", "Copropriétés", "Fosses septiques"],
    nearbyAreas: ["Nice", "Aspremont", "Levens", "Falicon"]
  },
  {
    slug: "levens",
    name: "Levens",
    postalCode: "06670",
    metaTitle: "Débouchage Canalisation Levens 06670 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Levens (06670). Village moyen-pays. WC, évier bouchés ? Devis gratuit.",
    description: "Levens, bourg authentique du moyen-pays niçois, est réputé pour son huile d'olive et son patrimoine préservé. Intervention experte dans ce cadre provençal.",
    quartiers: ["Village", "Plan du Var", "Saint-Antoine", "La Roquette"],
    localInfo: "Levens est un village typique avec moulin à huile et ruelles anciennes. Nos techniciens maîtrisent les interventions dans ce type de bâti traditionnel.",
    typicalProblems: ["Village ancien", "Moulins et commerces", "Fosses septiques", "Canalisations historiques"],
    nearbyAreas: ["Tourrette-Levens", "Duranus", "La Roquette-sur-Var", "Nice"]
  },
  {
    slug: "falicon",
    name: "Falicon",
    postalCode: "06950",
    metaTitle: "Débouchage Canalisation Falicon 06950 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Falicon (06950). Village perché Nice. WC, évier bouchés ? Devis gratuit.",
    description: "Falicon, village perché dominant Nice, offre une vue exceptionnelle sur la Baie des Anges. Intervention discrète dans ce village pittoresque.",
    quartiers: ["Village", "Mont Chauve", "Les Plans"],
    localInfo: "Falicon est célèbre pour sa pyramide et ses grottes. Ce village perché aux ruelles étroites nécessite un équipement adapté pour les interventions.",
    typicalProblems: ["Village perché", "Accès difficiles", "Canalisations anciennes", "Villas panoramiques"],
    nearbyAreas: ["Nice", "Tourrette-Levens", "La Trinité", "Aspremont"]
  },
  {
    slug: "la-trinite",
    name: "La Trinité",
    postalCode: "06340",
    metaTitle: "Débouchage Canalisation La Trinité 06340 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à La Trinité (06340). Proche Nice. WC, évier bouchés ? Devis gratuit.",
    description: "La Trinité, commune limitrophe de Nice dans la vallée du Paillon, est une ville résidentielle dynamique. Intervention rapide pour particuliers et professionnels.",
    quartiers: ["Centre", "Le Colomas", "Plan de la Trinité", "Saint-Sébastien"],
    localInfo: "La Trinité est une commune bien desservie aux portes de Nice. Nous intervenons rapidement dans cette ville où se mêlent habitat collectif et individuel.",
    typicalProblems: ["Copropriétés", "Maisons individuelles", "Commerces", "Zone industrielle"],
    nearbyAreas: ["Nice", "Drap", "Falicon", "L'Escarène"]
  },
  {
    slug: "drap",
    name: "Drap",
    postalCode: "06340",
    metaTitle: "Débouchage Canalisation Drap 06340 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Drap (06340). Vallée du Paillon. WC, évier bouchés ? Devis gratuit.",
    description: "Drap, commune de la vallée du Paillon aux portes de Nice, est une ville résidentielle en plein développement. Service professionnel garanti.",
    quartiers: ["Centre", "Le Vieux Drap", "Plan de Drap", "Les Marcellines"],
    localInfo: "Drap connaît un fort développement résidentiel tout en préservant son vieux village. Nous intervenons sur tous types de constructions.",
    typicalProblems: ["Vieux village", "Résidences neuves", "Copropriétés", "Commerces locaux"],
    nearbyAreas: ["La Trinité", "Nice", "Contes", "Peillon"]
  },
  {
    slug: "contes",
    name: "Contes",
    postalCode: "06390",
    metaTitle: "Débouchage Canalisation Contes 06390 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Contes (06390). Vallée du Paillon. WC, évier bouchés ? Devis gratuit.",
    description: "Contes, bourg historique de la vallée du Paillon, est une commune dynamique entre Nice et l'arrière-pays. Intervention professionnelle dans tous les quartiers.",
    quartiers: ["Centre", "Sclos", "La Vernéa", "Sainte-Marguerite"],
    localInfo: "Contes est un bourg actif avec commerces et services. Nous intervenons régulièrement auprès des particuliers et des professionnels de la commune.",
    typicalProblems: ["Vieille ville", "Commerces", "Résidences", "Zone artisanale"],
    nearbyAreas: ["Drap", "L'Escarène", "Berre-les-Alpes", "Peillon"]
  },
  {
    slug: "peillon",
    name: "Peillon",
    postalCode: "06440",
    metaTitle: "Débouchage Canalisation Peillon 06440 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Peillon (06440). Village médiéval. WC, évier bouchés ? Devis gratuit.",
    description: "Peillon, l'un des plus beaux villages perchés de la Côte d'Azur, est un joyau médiéval intact. Intervention experte avec matériel adapté aux accès difficiles.",
    quartiers: ["Peillon Village", "Sainte-Thècle", "Peillon-Gare"],
    localInfo: "Peillon est considéré comme l'un des villages les mieux préservés de la région. Ses ruelles étroites et ses maisons anciennes nécessitent une expertise particulière.",
    typicalProblems: ["Village médiéval intact", "Accès très difficiles", "Canalisations centenaires", "Ruelles piétonnes"],
    nearbyAreas: ["Peille", "La Turbie", "Drap", "L'Escarène"]
  },
  {
    slug: "peille",
    name: "Peille",
    postalCode: "06440",
    metaTitle: "Débouchage Canalisation Peille 06440 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Peille (06440). Village perché. WC, évier bouchés ? Devis gratuit.",
    description: "Peille, village médiéval perché à 630m d'altitude, domine la vallée du Paillon et la mer. Intervention professionnelle dans ce site exceptionnel.",
    quartiers: ["Village", "La Grave de Peille", "Saint-Martin"],
    localInfo: "Peille est un village authentique avec un riche patrimoine. Nos techniciens sont formés aux interventions dans les villages perchés aux accès complexes.",
    typicalProblems: ["Village perché altitude", "Canalisations anciennes", "Accès difficiles", "Maisons en pierre"],
    nearbyAreas: ["Peillon", "La Turbie", "L'Escarène", "Sainte-Agnès"]
  },
  {
    slug: "l-escarene",
    name: "L'Escarène",
    postalCode: "06440",
    metaTitle: "Débouchage Canalisation L'Escarène 06440 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à L'Escarène (06440). Moyen-pays niçois. WC, évier bouchés ? Devis gratuit.",
    description: "L'Escarène, bourg dynamique du moyen-pays niçois, est un carrefour important vers les stations de ski. Service professionnel toute l'année.",
    quartiers: ["Centre", "Touët-de-l'Escarène", "Place de la République"],
    localInfo: "L'Escarène est un bourg actif avec son église baroque remarquable. Nous intervenons dans cette commune qui accueille de nombreux visiteurs en route vers les stations.",
    typicalProblems: ["Bourg ancien", "Commerces et restaurants", "Copropriétés", "Passage touristique"],
    nearbyAreas: ["Contes", "Lucéram", "Peille", "Berre-les-Alpes"]
  },
  {
    slug: "luceram",
    name: "Lucéram",
    postalCode: "06440",
    metaTitle: "Débouchage Canalisation Lucéram 06440 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Lucéram (06440). Village médiéval crèches. WC, évier bouchés ? Devis gratuit.",
    description: "Lucéram, village médiéval célèbre pour son circuit des crèches, est un bijou d'architecture ancienne. Intervention soignée dans ce patrimoine préservé.",
    quartiers: ["Village", "Peira-Cava", "Les Granges"],
    localInfo: "Lucéram est renommé pour ses crèches de Noël et son patrimoine religieux exceptionnel. Nos interventions respectent ce cadre historique unique.",
    typicalProblems: ["Village médiéval", "Canalisations très anciennes", "Altitude", "Accès limités"],
    nearbyAreas: ["L'Escarène", "Peille", "Moulinet", "Sospel"]
  },
  {
    slug: "sospel",
    name: "Sospel",
    postalCode: "06380",
    metaTitle: "Débouchage Canalisation Sospel 06380 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Sospel (06380). Village frontière Italie. WC, évier bouchés ? Devis gratuit.",
    description: "Sospel, bourg historique de la vallée de la Bévéra, est une étape sur la route du sel vers l'Italie. Service professionnel dans ce cadre montagnard.",
    quartiers: ["Centre", "Pont Vieux", "Saint-Jean", "Caï"],
    localInfo: "Sospel possède un patrimoine exceptionnel avec son pont à péage médiéval. Nous intervenons avec respect dans ce site chargé d'histoire.",
    typicalProblems: ["Bourg historique", "Altitude montagne", "Pont médiéval", "Maisons anciennes"],
    nearbyAreas: ["Menton", "Breil-sur-Roya", "Moulinet", "Castillon"]
  },
  {
    slug: "breil-sur-roya",
    name: "Breil-sur-Roya",
    postalCode: "06540",
    metaTitle: "Débouchage Canalisation Breil-sur-Roya 06540 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Breil-sur-Roya (06540). Vallée de la Roya. WC, évier bouchés ? Devis gratuit.",
    description: "Breil-sur-Roya, au cœur de la vallée de la Roya, est un village provençal aux accents italiens. Intervention professionnelle dans ce territoire de montagne.",
    quartiers: ["Centre", "Libre", "Piène-Haute", "Piène-Basse"],
    localInfo: "Breil-sur-Roya est un carrefour de la vallée de la Roya avec une forte identité locale. Nous intervenons dans ce territoire parfois difficile d'accès.",
    typicalProblems: ["Village de montagne", "Canalisations anciennes", "Altitude", "Accès vallée"],
    nearbyAreas: ["Sospel", "Tende", "Saorge", "Fontan"]
  },
  {
    slug: "tende",
    name: "Tende",
    postalCode: "06430",
    metaTitle: "Débouchage Canalisation Tende 06430 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Tende (06430). Vallée des Merveilles. WC, évier bouchés ? Devis gratuit.",
    description: "Tende, porte d'entrée de la Vallée des Merveilles, est un bourg de montagne au riche patrimoine. Service professionnel dans ce territoire préservé.",
    quartiers: ["Centre", "Saint-Dalmas-de-Tende", "La Brigue", "Granile"],
    localInfo: "Tende est la commune la plus septentrionale des Alpes-Maritimes avec un patrimoine unique. Nos équipes sont équipées pour les interventions en montagne.",
    typicalProblems: ["Altitude montagne", "Hiver rigoureux", "Canalisations anciennes", "Tourisme vallée Merveilles"],
    nearbyAreas: ["La Brigue", "Saorge", "Fontan", "Limone Piemonte"]
  },
  {
    slug: "la-brigue",
    name: "La Brigue",
    postalCode: "06430",
    metaTitle: "Débouchage Canalisation La Brigue 06430 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à La Brigue (06430). Notre-Dame des Fontaines. WC, évier bouchés ? Devis gratuit.",
    description: "La Brigue, village de montagne célèbre pour Notre-Dame des Fontaines, est un joyau du patrimoine alpin. Intervention experte dans ce cadre exceptionnel.",
    quartiers: ["Village", "Morignole", "Notre-Dame des Fontaines"],
    localInfo: "La Brigue possède un patrimoine religieux exceptionnel avec la chapelle Notre-Dame des Fontaines. Nos interventions respectent ce cadre historique.",
    typicalProblems: ["Village montagne", "Patrimoine classé", "Altitude", "Canalisations anciennes"],
    nearbyAreas: ["Tende", "Saorge", "Triora", "Fontan"]
  },
  {
    slug: "saorge",
    name: "Saorge",
    postalCode: "06540",
    metaTitle: "Débouchage Canalisation Saorge 06540 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Saorge (06540). Village perché Roya. WC, évier bouchés ? Devis gratuit.",
    description: "Saorge, spectaculaire village perché en balcon sur la Roya, est l'un des plus beaux sites des Alpes-Maritimes. Intervention avec matériel adapté.",
    quartiers: ["Village", "Monastère", "Berghe"],
    localInfo: "Saorge est accroché à la montagne dans un site vertigineux. Ses ruelles en escalier et son accès unique nécessitent une expertise particulière.",
    typicalProblems: ["Village en balcon", "Accès très difficile", "Ruelles en escalier", "Canalisations historiques"],
    nearbyAreas: ["Breil-sur-Roya", "Fontan", "Tende", "La Brigue"]
  },
  {
    slug: "fontan",
    name: "Fontan",
    postalCode: "06540",
    metaTitle: "Débouchage Canalisation Fontan 06540 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Fontan (06540). Vallée de la Roya. WC, évier bouchés ? Devis gratuit.",
    description: "Fontan, village de la vallée de la Roya, est une commune de montagne au patrimoine préservé. Service professionnel adapté au territoire.",
    quartiers: ["Village", "Berghe Supérieur", "Berghe Inférieur"],
    localInfo: "Fontan est situé dans la vallée de la Roya, territoire parfois difficile d'accès. Nos équipes sont formées aux interventions en zone de montagne.",
    typicalProblems: ["Village montagne", "Accès vallée", "Canalisations rurales", "Altitude"],
    nearbyAreas: ["Saorge", "Breil-sur-Roya", "Tende", "La Brigue"]
  },
  {
    slug: "saint-andre-de-la-roche",
    name: "Saint-André-de-la-Roche",
    postalCode: "06730",
    metaTitle: "Débouchage Canalisation Saint-André-de-la-Roche 06730 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Saint-André-de-la-Roche (06730). Proche Nice. WC, évier bouchés ? Devis gratuit.",
    description: "Saint-André-de-la-Roche, commune limitrophe de Nice, est une ville résidentielle dynamique de la vallée du Paillon. Intervention rapide garantie.",
    quartiers: ["Centre", "La Lauvette", "Lingostière"],
    localInfo: "Saint-André-de-la-Roche est une commune résidentielle bien desservie à proximité immédiate de Nice. Nous intervenons rapidement pour tous vos besoins.",
    typicalProblems: ["Copropriétés", "Maisons individuelles", "Commerces", "Proximité Nice"],
    nearbyAreas: ["Nice", "La Trinité", "Drap", "Tourrette-Levens"]
  },
  {
    slug: "saint-martin-du-var",
    name: "Saint-Martin-du-Var",
    postalCode: "06670",
    metaTitle: "Débouchage Canalisation Saint-Martin-du-Var 06670 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Saint-Martin-du-Var (06670). WC, évier bouchés ? Devis gratuit.",
    description: "Saint-Martin-du-Var, commune de la vallée du Var, bénéficie d'une situation privilégiée entre Nice et l'arrière-pays. Service professionnel garanti.",
    quartiers: ["Centre", "Plan Martin", "La Roquette"],
    localInfo: "Saint-Martin-du-Var est une commune en développement avec de nombreuses constructions récentes. Nous intervenons sur tous types d'installations.",
    typicalProblems: ["Constructions neuves", "Villas", "Copropriétés", "Zone commerciale"],
    nearbyAreas: ["Carros", "La Roquette-sur-Var", "Colomars", "Nice"]
  },
  {
    slug: "la-roquette-sur-siagne",
    name: "La Roquette-sur-Siagne",
    postalCode: "06550",
    metaTitle: "Débouchage Canalisation La Roquette-sur-Siagne 06550 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à La Roquette-sur-Siagne (06550). WC, évier bouchés ? Devis gratuit.",
    description: "La Roquette-sur-Siagne, commune entre Cannes et Grasse, est un village provençal en plein développement. Intervention rapide dans tous les quartiers.",
    quartiers: ["Village", "Plan de la Tour", "Les Music"],
    localInfo: "La Roquette-sur-Siagne connaît un fort développement résidentiel tout en préservant son caractère provençal. Nous intervenons auprès des particuliers et entreprises.",
    typicalProblems: ["Village ancien", "Résidences neuves", "Fosses septiques", "Zone d'activités"],
    nearbyAreas: ["Pégomas", "Mouans-Sartoux", "Grasse", "Mandelieu"]
  },
  {
    slug: "le-tignet",
    name: "Le Tignet",
    postalCode: "06530",
    metaTitle: "Débouchage Canalisation Le Tignet 06530 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation au Tignet (06530). Arrière-pays grassois. WC, évier bouchés ? Devis gratuit.",
    description: "Le Tignet, commune résidentielle de l'arrière-pays grassois, offre un cadre de vie paisible. Service professionnel pour tous vos problèmes de canalisation.",
    quartiers: ["Centre", "Les Parcs", "Saint-Marc"],
    localInfo: "Le Tignet est une commune résidentielle prisée pour son calme et sa proximité avec Grasse. Nombreuses maisons individuelles avec fosses septiques.",
    typicalProblems: ["Maisons individuelles", "Fosses septiques", "Jardins", "Canalisations rurales"],
    nearbyAreas: ["Peymeinade", "Spéracèdes", "Cabris", "Grasse"]
  },
  {
    slug: "speracedes",
    name: "Spéracèdes",
    postalCode: "06530",
    metaTitle: "Débouchage Canalisation Spéracèdes 06530 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Spéracèdes (06530). Village grassois. WC, évier bouchés ? Devis gratuit.",
    description: "Spéracèdes, petit village provençal près de Grasse, est une commune résidentielle au charme authentique. Intervention professionnelle garantie.",
    quartiers: ["Village", "Les Plans", "Saint-Jean"],
    localInfo: "Spéracèdes est un village paisible de l'arrière-pays grassois. Ses maisons traditionnelles et constructions récentes bénéficient de notre expertise.",
    typicalProblems: ["Village provençal", "Fosses septiques", "Maisons anciennes", "Villas récentes"],
    nearbyAreas: ["Le Tignet", "Cabris", "Peymeinade", "Grasse"]
  },
  {
    slug: "cabris",
    name: "Cabris",
    postalCode: "06530",
    metaTitle: "Débouchage Canalisation Cabris 06530 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Cabris (06530). Village perché vue mer. WC, évier bouchés ? Devis gratuit.",
    description: "Cabris, village perché offrant une vue exceptionnelle jusqu'à la mer, est un site classé de l'arrière-pays grassois. Service discret et professionnel.",
    quartiers: ["Village", "Les Vignes", "Mauvans"],
    localInfo: "Cabris offre un panorama exceptionnel des Alpes à la mer. Ce village perché aux ruelles étroites nécessite une expertise particulière pour les interventions.",
    typicalProblems: ["Village perché", "Ruelles étroites", "Canalisations anciennes", "Villas vue mer"],
    nearbyAreas: ["Grasse", "Spéracèdes", "Saint-Vallier-de-Thiey", "Peymeinade"]
  },
  {
    slug: "saint-vallier-de-thiey",
    name: "Saint-Vallier-de-Thiey",
    postalCode: "06460",
    metaTitle: "Débouchage Canalisation Saint-Vallier-de-Thiey 06460 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Saint-Vallier-de-Thiey (06460). WC, évier bouchés ? Devis gratuit.",
    description: "Saint-Vallier-de-Thiey, bourg provençal sur la route Napoléon, est un centre actif de l'arrière-pays grassois. Intervention professionnelle garantie.",
    quartiers: ["Centre", "Les Plans", "Malamaire", "Le Jas"],
    localInfo: "Saint-Vallier-de-Thiey est un bourg dynamique avec commerces et services. Nous intervenons auprès des particuliers et des professionnels de la commune.",
    typicalProblems: ["Bourg actif", "Commerces", "Maisons de village", "Zone résidentielle"],
    nearbyAreas: ["Grasse", "Cabris", "Escragnolles", "Saint-Cézaire-sur-Siagne"]
  },
  {
    slug: "saint-cezaire-sur-siagne",
    name: "Saint-Cézaire-sur-Siagne",
    postalCode: "06530",
    metaTitle: "Débouchage Canalisation Saint-Cézaire-sur-Siagne 06530 - Urgence 24h/24 | Alpes Debouchage ☎ 07 44 87 87 63",
    metaDescription: "Expert débouchage canalisation à Saint-Cézaire-sur-Siagne (06530). Grottes. WC, évier bouchés ? Devis gratuit.",
    description: "Saint-Cézaire-sur-Siagne, célèbre pour ses grottes, est un village provençal authentique de l'arrière-pays grassois. Service professionnel garanti.",
    quartiers: ["Village", "Les Grottes", "Plan de Saint-Cézaire"],
    localInfo: "Saint-Cézaire-sur-Siagne est connu pour ses grottes spectaculaires. Ce village perché préserve son authenticité et nécessite des interventions adaptées.",
    typicalProblems: ["Village perché", "Terrain karstique", "Canalisations anciennes", "Fosses septiques"],
    nearbyAreas: ["Saint-Vallier-de-Thiey", "Grasse", "Cabris", "Montauroux"]
  }
];

export const debouchageImages = {
  pompe: "https://customer-assets.emergentagent.com/job_0ab86c0e-4c4f-4ff6-8208-82e18036900c/artifacts/ub9nmn6u_942bcdaf-dd46-45be-a688-fe59fc0feba3.jpeg",
  camion: "https://customer-assets.emergentagent.com/job_0ab86c0e-4c4f-4ff6-8208-82e18036900c/artifacts/eyie51aq_2ab4370d-1d23-42df-bb80-8b8bc30743af.jpeg",
  camera: "https://customer-assets.emergentagent.com/job_0ab86c0e-4c4f-4ff6-8208-82e18036900c/artifacts/57hunb5n_b5d348ed-6d4c-4b65-a76d-319bf33035ba.jpeg",
  bacGraisse: "https://customer-assets.emergentagent.com/job_0ab86c0e-4c4f-4ff6-8208-82e18036900c/artifacts/mf96pjx5_32264f78-cbe1-429a-91d8-4d43997d1cd2.jpeg",
  pompeRelevage: "https://customer-assets.emergentagent.com/job_0ab86c0e-4c4f-4ff6-8208-82e18036900c/artifacts/8jwx5wyv_216fb42e-bb29-4739-acbe-112b69c37427.jpeg"
};

export const serviceTypes = [
  {
    slug: "inspection-camera",
    name: "Inspection Caméra Canalisation",
    shortName: "Inspection Caméra Canalisation",
    price: "249",
    image: "https://customer-assets.emergentagent.com/job_0ab86c0e-4c4f-4ff6-8208-82e18036900c/artifacts/57hunb5n_b5d348ed-6d4c-4b65-a76d-319bf33035ba.jpeg",
    description: "Contrôle et diagnostic de vos canalisations par caméra endoscopique haute définition.",
    longDescription: "L'inspection caméra permet de contrôler les réseaux d'évacuation, détecter les canalisations cassées, vérifier après des travaux effectués par des promoteurs ou constructeurs qu'il n'y a pas de déchets ou détritus et que les canalisations sont bien raccordées.",
    targets: ["Particuliers", "Syndics", "Promoteurs immobiliers", "Constructeurs", "Copropriétés", "Entreprises"],
    features: [
      "Caméra endoscopique HD",
      "Localisation précise des problèmes",
      "Rapport détaillé avec images",
      "Contrôle après travaux",
      "Détection canalisations cassées",
      "Vérification des raccordements"
    ],
    useCases: [
      "Contrôle des réseaux d'évacuation",
      "Recherche de canalisation cassée",
      "Vérification après travaux de construction",
      "Contrôle avant achat immobilier",
      "Détection de racines dans les canalisations",
      "Localisation d'un bouchon"
    ]
  },
  {
    slug: "entretien-bac-graisse",
    name: "Entretien Bac à Graisse",
    shortName: "Entretien Bac à Graisse",
    price: "289",
    image: "https://customer-assets.emergentagent.com/job_0ab86c0e-4c4f-4ff6-8208-82e18036900c/artifacts/mf96pjx5_32264f78-cbe1-429a-91d8-4d43997d1cd2.jpeg",
    description: "Vidange et entretien de bacs à graisse pour les professionnels de la restauration.",
    longDescription: "L'entretien des bacs à graisse est obligatoire pour tous les établissements manipulant des graisses alimentaires : restaurants, traiteurs, cantines, cuisines professionnelles. Un entretien régulier évite les mauvaises odeurs, les bouchons et les sanctions.",
    targets: ["Restaurateurs", "Traiteurs", "Cantines scolaires", "Cuisines collectives", "Hôtels", "Fast-foods", "Boulangeries"],
    features: [
      "Pompage intégral des graisses",
      "Nettoyage haute pression",
      "Remise en service immédiate",
      "Contrat d'entretien annuel",
      "Certificat de vidange",
      "Conformité réglementaire"
    ],
    useCases: [
      "Vidange périodique obligatoire",
      "Entretien préventif",
      "Débouchage bac saturé",
      "Mise en conformité",
      "Contrat annuel d'entretien",
      "Nettoyage après contrôle sanitaire"
    ]
  },
  {
    slug: "pompe-relevage",
    name: "Entretien Pompe de Relevage",
    shortName: "Entretien Pompe de Relevage",
    price: "279",
    image: "https://customer-assets.emergentagent.com/job_0ab86c0e-4c4f-4ff6-8208-82e18036900c/artifacts/8jwx5wyv_216fb42e-bb29-4739-acbe-112b69c37427.jpeg",
    description: "Entretien, réparation et contrat de maintenance pour pompes de relevage.",
    longDescription: "Les pompes de relevage sont essentielles pour les évacuations en contre-pente, les sous-sols, les zones avec nappes phréatiques ou les problèmes d'évacuation. Un entretien régulier garantit leur bon fonctionnement et prolonge leur durée de vie.",
    targets: ["Particuliers avec sous-sol", "Copropriétés", "Immeubles", "Commerces en sous-sol", "Parkings souterrains", "Maisons en zone inondable"],
    features: [
      "Entretien préventif annuel",
      "Diagnostic complet",
      "Intervention prioritaire",
      "Dépannage 24h/24",
      "Garantie sur le matériel",
      "Remplacement si nécessaire"
    ],
    useCases: [
      "Sous-sols et caves",
      "Évacuations en contre-pente",
      "Zones de nappes phréatiques",
      "Parkings souterrains",
      "WC en sous-sol",
      "Maisons en contrebas"
    ]
  },
  {
    slug: "curage-haute-pression",
    name: "Curage Haute Pression",
    shortName: "Curage Haute Pression",
    price: "289",
    image: "https://customer-assets.emergentagent.com/job_0ab86c0e-4c4f-4ff6-8208-82e18036900c/artifacts/eyie51aq_2ab4370d-1d23-42df-bb80-8b8bc30743af.jpeg",
    description: "Nettoyage complet de vos canalisations par hydrocurage haute pression jusqu'à 300 bars.",
    longDescription: "Le curage haute pression permet un nettoyage en profondeur de vos canalisations. Notre camion hydrocureur élimine efficacement les graisses, le calcaire, les dépôts et tous les résidus accumulés pour un résultat durable.",
    targets: ["Particuliers", "Copropriétés", "Restaurants", "Industries", "Communes", "Syndics"],
    features: [
      "Camion hydrocureur",
      "Pression jusqu'à 300 bars",
      "100% écologique (eau uniquement)",
      "Élimination graisses et calcaire",
      "Travail en profondeur",
      "Résultat garanti"
    ],
    useCases: [
      "Canalisations encrassées",
      "Élimination du calcaire",
      "Nettoyage préventif annuel",
      "Après un débouchage",
      "Colonnes d'immeuble",
      "Réseaux d'évacuation"
    ]
  },
  {
    slug: "plombier-debouchage",
    name: "Plombier Débouchage",
    shortName: "Plombier Débouchage",
    price: "179",
    image: "https://customer-assets.emergentagent.com/job_0ab86c0e-4c4f-4ff6-8208-82e18036900c/artifacts/ub9nmn6u_942bcdaf-dd46-45be-a688-fe59fc0feba3.jpeg",
    description: "Plombier spécialisé en débouchage de canalisations. Intervention rapide 24h/24.",
    longDescription: "Votre plombier déboucheur professionnel intervient en urgence pour tous vos problèmes de canalisations bouchées. WC bouché, évier bloqué, douche qui ne s'écoule plus ? Nous intervenons rapidement avec du matériel professionnel pour déboucher efficacement et durablement.",
    targets: ["Particuliers", "Professionnels", "Syndics", "Copropriétés", "Restaurants", "Hôtels", "Commerces"],
    features: [
      "Intervention rapide 24h/24",
      "Plombier qualifié et expérimenté",
      "Matériel professionnel",
      "Débouchage garanti",
      "Devis gratuit",
      "Pas de majoration le week-end"
    ],
    useCases: [
      "WC bouché",
      "Évier bloqué",
      "Douche qui ne s'écoule plus",
      "Baignoire bouchée",
      "Lavabo obstrué",
      "Canalisation engorgée"
    ]
  }
];

export const images = {
  hero: "https://images.unsplash.com/photo-1649012206726-63f52afd3dc4?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxDYW5uZXMlMjBGcmVuY2glMjBSaXZpZXJhfGVufDB8fHx8MTc2OTA4OTMwMnww&ixlib=rb-4.1.0&q=75&w=1200",
  cannes: "https://images.unsplash.com/photo-1649012300854-f787855e95e5?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxDYW5uZXMlMjBGcmVuY2glMjBSaXZpZXJhfGVufDB8fHx8MTc2OTA4OTMwMnww&ixlib=rb-4.1.0&q=75&w=1920",
  plumber: "https://images.unsplash.com/photo-1635221798248-8a3452ad07cd?fm=webp&q=75&w=800",
  pipes: "https://images.unsplash.com/photo-1650246363606-a2402ec42b08?crop=entropy&cs=srgb&fm=webp&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBwbHVtYmVyfGVufDB8fHx8MTc2OTA4OTI4OXww&ixlib=rb-4.1.0&q=75&w=800",
  drain: "https://images.unsplash.com/photo-1700174542278-4f8fc5ab6565?crop=entropy&cs=srgb&fm=webp&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxkcmFpbiUyMGNsZWFuaW5nfGVufDB8fHx8MTc2OTA4OTI5NHww&ixlib=rb-4.1.0&q=75&w=800",
  system: "https://images.unsplash.com/photo-1765277789190-22f77c5e7046?crop=entropy&cs=srgb&fm=webp&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHx3YXRlciUyMHBpcGUlMjBzeXN0ZW18ZW58MHx8fHwxNzY5MDg5MzA4fDA&ixlib=rb-4.1.0&q=75&w=800"
};